import {SelectedBranchStates} from "../../States";
import {SetGlobalCompanyId} from "../../../Helpers";

/**
 * update selected branch handler
 * @param payload
 * @returns {*}
 */
export function updateSelectedBranch(payload) {
    if (!payload) return null;

    localStorage.setItem('selectedBranch', JSON.stringify(payload));
    localStorage.setItem('company_uuid', payload.uuid || null);
    SetGlobalCompanyId(payload.uuid);

    return {
        type: SelectedBranchStates.SUCCESS,
        payload,
    }
}
